import { BASE_URL_CLIENT_V2, ROUTES } from './constants';

const API_ROOT = `${BASE_URL_CLIENT_V2}/${ROUTES.CLIENT_V2}`;

const ENDPOINTS = {
  SEND_OTP: `${API_ROOT}/user/send-otp`,
  VERIFY_OTP: `${API_ROOT}/user/verify-otp`,
  RESEND_OTP: `${API_ROOT}/user/resend-otp`,
  GET_PROFILE: `${API_ROOT}/user/get-profile`,
  RBZ_IAPS_WEB: `${API_ROOT}/rbz/iaps-web`,
  RBZ_HOME: `${API_ROOT}/rbz/home`,
  RBZ_REDEEM: `${API_ROOT}/rbz/redeem`,
  RBZ_MY_REWARDS: `${API_ROOT}/rbz/my-rewards`,
  rbzMyRewardById: (id) => `${API_ROOT}/rbz/my-rewards/${encodeURIComponent(id)}`,
  HOME_MY_REWARDS: `${API_ROOT}/home/my-rewards`,
  homeMyRewardById: (id) => `${API_ROOT}/home/my-rewards/${encodeURIComponent(id)}`,
  USER_WEB_IAPS_PURCHASE: `${API_ROOT}/user/web/iaps/purchase`,
  PAYMENTS_VERIFY: `${API_ROOT}/payments/verify`,
  USER_TRANSACTIONS: `${API_ROOT}/user/transactions`,
  USER_IAPS_TRANSACTIONS: `${API_ROOT}/user/iaps/transactions`,
  USER_REFERRALS: `${API_ROOT}/user/my-referrals`,
  userAboutXp: (slug) => `${API_ROOT}/user/about-xp/${encodeURIComponent(slug)}`,
};

export default ENDPOINTS;
